import { appRoutes } from './appRouteConfig';

export const roleBasedPermission = {
	[appRoutes.createTrip]: ['traveller', 'client', 'admin'],
	[appRoutes.teamEvents]: ['traveller', 'client', 'admin'],
};
